import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';

import { SlatePlugin } from '../../../../../../slatePlugins/slatePlugins.types';
import {
  ELEMENT_IELTS_CALENDAR_COMPUTER_BASED,
  IeltsCalendarComputerBasedOptions,
} from './IeltsCalendarComputerBasedPlugin.types';

const IeltsCalendarElementReadOnly = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(() =>
    import(
      /* webpackExports: "IeltsCalendarElementReadOnly" */ './components/IeltsCalendarElement'
    ).then((mod) => mod.IeltsCalendarElementReadOnly)
  )
);

export const IeltsCalendarComputerBasedReadOnlyPlugin = (
  options?: IeltsCalendarComputerBasedOptions
): SlatePlugin => ({
  renderElement: (renderProps: RenderElementProps) => {
    const { element } = renderProps;
    if (element?.type === ELEMENT_IELTS_CALENDAR_COMPUTER_BASED) {
      return <IeltsCalendarElementReadOnly {...renderProps} {...options} />;
    }
    return undefined;
  },
  voidTypes: [ELEMENT_IELTS_CALENDAR_COMPUTER_BASED],
});
